import { Injectable } from '@angular/core';
import { RESTServiceBase } from '../../common/service.base';
import { FormDescriptor } from './model/form';
import { List } from '../../common/model/List_T';
import { AppConfig } from '../../configuration/app.config';
import { AuthService } from '../../services/auth.service';
import { View } from '../../common/model/view';
import { IDataService } from '../common/IDataService';
import { CustomPropTypeService } from '../customprop.type/customprop.type.service';
import { CustomPropValueService } from '../customprop.value/customprop.value.service';

@Injectable()
export class FormService extends RESTServiceBase implements IDataService<FormDescriptor> {

  constructor(
    private authService: AuthService,
    private customPropTypeService: CustomPropTypeService,
    private customPropValueService: CustomPropValueService,
    private config: AppConfig
  ) {
    super(
      'v1',
      'FormManagement',
      authService,
      config.FMSConfig
    );
  }

  public create(form: FormDescriptor): Promise<FormDescriptor> {
    return super.post<FormDescriptor>(
      new FormDescriptor({
        id: undefined,
        href: undefined,

        identifier: form.identifier,
        version: form.version,
        title: form.title,
        designerId: form.designerId,
        clerkId: form.clerkId,
        validFrom: form.validFrom,
        validUntil: form.validUntil,
        frequency: form.frequency,
        usedAsTemplate: form.usedAsTemplate,
        parentFormId: form.parentFormId,
        prequisiteFormId: form.prequisiteFormId,
        prequisiteFormFieldAliasForReference: form.prequisiteFormFieldAliasForReference,
        masterFormId: form.masterFormId,
        directDownloadOnly: form.directDownloadOnly,
        enableUpload: form.enableUpload,
        assignedWorkflowTemplates: form.assignedWorkflowTemplates,
        enableSecondaryValidation: form.enableSecondaryValidation,
        enableBatchExport: form.enableBatchExport,
        formType: form.formType,
        capabilities: form.capabilities,
        modified: form.modified,
        deleted: form.deleted
      }));
  }

  public getForms(view?: View): Promise<List<FormDescriptor>> {
    return super.get<List<FormDescriptor>>(undefined, view);
  }

  public async list(view?: View): Promise<List<FormDescriptor>> {
    const forms = await super.post<List<FormDescriptor>>(view, undefined, "list");
    forms.value = forms.value.map(f => new FormDescriptor(f));
    return forms as List<FormDescriptor>;
  }

  async GetList(v: View): Promise<List<FormDescriptor>> {
    return await this.list(v);
  }
  async GetById(id: string): Promise<FormDescriptor> {
    return await this.getById(id);
  }
  public delete(id: string): Promise<void> {
    return super.delete(id);
  }

  public update(id: string, form: FormDescriptor): Promise<FormDescriptor> {
    return super.put<FormDescriptor>(id, form);
  }

  public getById(id: string): Promise<FormDescriptor> {
    return super.get<FormDescriptor>(id);
  }

  public recreate(id: string): Promise<void> {
    return super.post(null, id, 'recreate');
  }

  public async isServiceAvailable(): Promise<boolean> {
    return await super.isServiceAvailable();
  }

  static szakteruletSzerepkorCache: any = {};
  
  public async GetClarificationSzakteruletSzerepkor(id: string): Promise<string | undefined> {
    if (this.authService.hasAccess('Public', undefined)) return undefined;

    var v = FormService.szakteruletSzerepkorCache[id];

    if (!v) {
      var cpt = await this.customPropTypeService.GetCustomPropertyByName("ModKerelemAdatEgyeztetesSzakteruletiSzerepkor","Form");
      if (!cpt) return;

      var view = new View();
      view.addFilter("CustomPropTypeId", cpt.id);
      view.addFilter("RelatedObjectId", id);
      var cpvs = await this.customPropValueService.GetList(view);
      if (cpvs && cpvs.value && cpvs.value.length) {
       v = cpvs.value[0].value;
      } 

      FormService.szakteruletSzerepkorCache[id] = v;
    }

    return v;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/form/form.service.ts